export default __webpack_public_path__ + "static/01-e8f9d073e2dd2e5f5324c22799837fdd.webp";